const About = () => {
  return (
    <section id="about" className="section section-alt">
      <div className="container mx-auto">
        <div className="grid lg:grid-cols-2 gap-8 md:gap-12 lg:gap-16 items-center">
          {/* Image Side */}
          <div className="relative">
            <div className="aspect-[3/4] overflow-hidden rounded-lg">
              <img
                src="https://images.unsplash.com/photo-1562322140-8baeececf3df?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80"
                alt="Frisör Selma"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Content Side */}
          <div className="space-y-4 sm:space-y-6">
            <div>
              <p className="text-heading mb-3 sm:mb-4 text-sm sm:text-base">Om Hårgalleriet</p>
              <h2 className="text-3xl sm:text-4xl md:text-5xl mb-4 sm:mb-6">En exklusiv oas för allt inom hår</h2>
            </div>

            <div className="space-y-3 sm:space-y-4 text-[var(--color-text-secondary)] leading-relaxed text-sm sm:text-base">
              <p>
                Selma, ägare med över 20 års erfarenhet i branschen och innehavare av både
                gesällbrev och mästarbrev samt mästarutbildning inom extensions, hade en vision:
                att skapa något unikt i Limhamn.
              </p>
              <p>
                En plats där kunder kan ta en paus från vardagen och njuta av en lyxig stund
                i en vackert designad salong. Resultatet blev Hårgalleriet – en exklusiv oas
                för allt inom hår.
              </p>
              <p>
                Vi strävar efter att bygga långvariga relationer med våra kunder för att
                säkerställa att de känner sig bekväma och litar på oss med sina hårbehov.
                Varje behandling utförs med endast produkter av högsta kvalitet.
              </p>
            </div>

            {/* Highlights */}
            <div className="grid grid-cols-3 gap-4 sm:gap-6 pt-6 sm:pt-8 border-t border-[var(--color-border-medium)]">
              <div className="text-center">
                <div className="text-2xl sm:text-3xl mb-1 sm:mb-2" style={{ color: 'var(--color-accent-500)' }}>20+</div>
                <p className="text-xs sm:text-sm text-[var(--color-text-secondary)]">års erfarenhet</p>
              </div>
              <div className="text-center">
                <div className="text-2xl sm:text-3xl mb-1 sm:mb-2" style={{ color: 'var(--color-accent-500)' }}>★</div>
                <p className="text-xs sm:text-sm text-[var(--color-text-secondary)]">Mästarbrev</p>
              </div>
              <div className="text-center">
                <div className="text-2xl sm:text-3xl mb-1 sm:mb-2" style={{ color: 'var(--color-accent-500)' }}>♥</div>
                <p className="text-xs sm:text-sm text-[var(--color-text-secondary)]">Personlig service</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
